import common from "./common";
import auth from "./auth";
import automations from "./automations";
import segments from "./segments";
import notifications from "./notifications";
import emailReport from "./email_report";
import inbox from "./inbox";
import visualEditor from "./visual_editor";
import support from "./support";
import dashboard from "./dashboard";
import coupons from "./coupons";
import header from "./header";
import account from "./account";
import places from "./places";
import plans from "./plans";
import dataSets from "./data-sets";
import settings from "./settings";
import whatsappInstances from "./whatsapp";
import balance from "./balance";
import customEvents from "./custom_events";
import clientFields from "./client_fields";
import orderFields from "./order_fields";
import quotationFields from "./quotation_fields";
import orderStatus from "./order_status";
import quotationStatus from "./quotation_status";
import notificationSchedule from "./notification_schedule";
import utmAuto from "./utm_auto";
import agentAuthorizations from "./agent_authorizations";
import filesGallery from "./files_gallery";
import clientsDeletion from "./clients_deletion";
import forms from "./forms";
import importHistory from "./import_history";
import imports from "./imports";
import mergeClients from "./merge_clients";
import tasks from "./tasks";
import rfmReport from "./rfm_report";
import orderReports from "./order_reports";
import tasksReport from "./tasks_report";
import retentionReport from "./retention_report";
import clientsReport from "./clients_report";
import clients from "./clients";
import clientsImportOrders from "./clients_import_orders";
import clientsImportClients from "./clients_import_clients";
import clientForm from "./client_form";
import pagination from "./pagination";
import couponsReport from "./coupons_report";
import orders from "./orders";
import grid from "./grid";
import reportFilters from "./report_filters";
import pdv from "./pdv";
import invoices from "./invoices";
import benefitsCenter from "./benefits_center";
import users from "./users";

export default {
    ...common,
    rfm_report: rfmReport,
    login: auth,
    clients: clients,
    clientsImportOrders: clientsImportOrders,
    clientsImportClients: clientsImportClients,
    clientForm: clientForm,
    pagination: pagination,
    automations: automations,
    account: account,
    places: places,
    plans: plans,
    dataSets: dataSets,
    settings: settings,
    customEvents: customEvents,
    clientFields: clientFields,
    utmAuto: utmAuto,
    agentAuthorizations: agentAuthorizations,
    filesGallery: filesGallery,
    tasks: tasks,
    segments: segments,
    orderReports: orderReports,
    retentionReport: retentionReport,
    clientsReport: clientsReport,
    notifications: notifications,
    emailReport: emailReport,
    couponsReport: couponsReport,
    inbox: inbox,
    orders: orders,
    grid: grid,
    pdv: pdv,
    reportFilters: reportFilters,
    visualEditor: visualEditor.emailEditor
        ? visualEditor
        : { visualEditor: visualEditor },
    support: support,
    dashboard: dashboard,
    coupons: coupons,
    header: header,
    whatsappInstances: whatsappInstances,
    balance: balance,
    orderFields: orderFields,
    quotationFields: quotationFields,
    orderStatus: orderStatus,
    quotationStatus: quotationStatus,
    notificationSchedule: notificationSchedule,
    clientsDeletion: clientsDeletion,
    mergeClients: mergeClients,
    importHistory: importHistory,
    imports: imports,
    forms: forms,
    tasks_report: tasksReport,
    invoices: invoices,
    benefitsCenter: benefitsCenter,
    users: users
};
